import { PiecePreview } from "./Piece";
import { usePreferences } from "../context/PreferencesContext";
import { getOwnerLabels } from "../game/pieceThemes";

/**
 * Shared game UI panel used in local/AI/online pages.
 * variant="sidebar" — colonne verticale (mode IA plein écran).
 */
export function ScorePanel({ turn, winner, captures, you = null, pieceTheme: pieceThemeProp = null, moves = null, variant = "bar" }) {
  const { pieceTheme: prefTheme } = usePreferences();
  const pieceTheme = pieceThemeProp || prefTheme;
  const { A: labelA, B: labelB } = getOwnerLabels(pieceTheme);

  if (variant === "sidebar") {
    return (
      <div className="glass rounded-lg p-4 w-full space-y-4" data-testid="score-panel">
        <p className="text-[10px] tracking-[0.25em] text-[color:var(--text-secondary)]">PARTIE</p>

        {winner ? (
          <div className="text-[color:var(--primary)] font-semibold text-sm" data-testid="winner-banner">
            Victoire {winner === "A" ? labelA : labelB} !
          </div>
        ) : (
          <div data-testid="turn-indicator">
            <div className="text-[10px] tracking-[0.2em] text-[color:var(--text-secondary)] mb-1">TOUR</div>
            <div className="text-sm font-semibold text-[color:var(--primary)]">
              {turn === "A" ? "Blancs" : "Noirs"}
            </div>
          </div>
        )}

        <div className="space-y-3" data-testid="captures-count">
          <div className="flex items-center gap-2" data-testid="score-A">
            <PiecePreview owner="A" themeId={pieceTheme} size={20} />
            <div className="min-w-0">
              <div className="text-[10px] text-[color:var(--text-secondary)] truncate">
                {labelA}{you === "A" ? " · vous" : ""}
              </div>
              <div className="text-sm font-semibold">{captures.A} prise{captures.A !== 1 ? "s" : ""}</div>
            </div>
          </div>
          <div className="flex items-center gap-2" data-testid="score-B">
            <PiecePreview owner="B" themeId={pieceTheme} size={20} />
            <div className="min-w-0">
              <div className="text-[10px] text-[color:var(--text-secondary)] truncate">
                {labelB}{you === "B" ? " · vous" : ""}
              </div>
              <div className="text-sm font-semibold">{captures.B} prise{captures.B !== 1 ? "s" : ""}</div>
            </div>
          </div>
        </div>

        {moves != null && (
          <div>
            <div className="text-[10px] tracking-[0.2em] text-[color:var(--text-secondary)] mb-1">COUPS</div>
            <div className="text-sm font-medium">{moves}</div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="glass rounded-lg p-4 sm:p-5 w-full max-w-[560px] mx-auto mb-4" data-testid="score-panel">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3" data-testid="score-A">
          <PiecePreview owner="A" themeId={pieceTheme} size={22} />
          <div>
            <div className="text-xs tracking-[0.2em] text-[color:var(--text-secondary)]">
              JOUEUR A {you === "A" && "· VOUS"}
            </div>
            <div className="text-sm font-semibold">{labelA}</div>
          </div>
        </div>
        <div className="text-center">
          {winner ? (
            <div className="text-[color:var(--primary)] font-semibold tracking-wide" data-testid="winner-banner">
              Victoire {winner === "A" ? labelA : labelB} !
            </div>
          ) : (
            <div className="text-xs tracking-[0.2em] text-[color:var(--text-secondary)]" data-testid="turn-indicator">
              TOUR · <span className="text-[color:var(--primary)]">{turn === "A" ? "BLANCS" : "NOIRS"}</span>
            </div>
          )}
          <div className="text-xs text-[color:var(--text-secondary)] mt-1" data-testid="captures-count">
            Captures — A: {captures.A} · B: {captures.B}
          </div>
        </div>
        <div className="flex items-center gap-3" data-testid="score-B">
          <div className="text-right">
            <div className="text-xs tracking-[0.2em] text-[color:var(--text-secondary)]">
              JOUEUR B {you === "B" && "· VOUS"}
            </div>
            <div className="text-sm font-semibold">{labelB}</div>
          </div>
          <PiecePreview owner="B" themeId={pieceTheme} size={22} />
        </div>
      </div>
    </div>
  );
}
